<template>
  <div v-if="stock_take_order">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('StockTakes', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/stock-take-orders/' + stock_take_order.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{
          $t("CRUD.viewInfo", [$t("StockTakeOrders.ObjectName")])
        }}</span>
      </v-tooltip>
      <!-- 导出 -->
      <v-tooltip
        top
        v-if="
          showExport &&
          $permission.permissionAllow('StockTakes', 'detailExport')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="stockTakeOrdersExport()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("StockTakeOrders.actions.export") }}
          </v-btn>
        </template>
        <span>{{ $t("StockTakeOrders.actions.export") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showStockTake &&
          ($permission.permissionAllow('StockTakes', 'stockTake') ||
            $permission.permissionAllow('StockTakes', 'positionStockTake'))
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('stockTake')
                  : $router.push(
                      '/stock-take-orders/' + stock_take_order.id + '/stockTake'
                    );
              })
            "
          >
            {{ $t("StockTakeOrders.actions.stockTake") }}
          </v-btn>
        </template>
        <span>{{ $t("StockTakeOrders.actions.stockTake") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="showCancel && $permission.permissionAllow('StockTakes', 'cancel')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelAlert = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("StockTakeOrders.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("StockTakeOrders.actions.cancelStockStakeOrder") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          false && $permission.permissionAllow('StockTakes', 'detailExport')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("StockTakeOrders.actions.export") }}
          </v-btn>
        </template>
        <span>{{
          $t("StockTakeOrders.actions.StockTakeOrderDetailExport")
        }}</span>
      </v-tooltip>
    </v-sheet>

    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('StockTakeOrders.ObjectName')"
      :code="stock_take_order.stock_take_code"
      @confirm="doAction('cancel')"
    />
  </div>
</template>

<script>
import DialogDelete from "@/components/plugins/DialogDelete";
import StockTakeOrders from "@/api/stock_take_orders";
export default {
  name: "StockTakeOrderActions",

  components: {
    DialogDelete,
  },

  props: {
    stock_take_order: Object,
    detailMode: Boolean,
    showView: Boolean,
    showStockTake: Boolean,
    showCancel: Boolean,
    showExport: Boolean,
  },

  data: () => ({
    printBtnMenu: false,
    exportBtnMenu: false,
    cancelAlert: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "cancel")
        return StockTakeOrders.cancel(this.stock_take_order.id);
    },
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$emit("done");
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          console.log(mode);
          // TODO print
        }.bind(this)
      );
    },
     stockTakeOrdersExport() {
      StockTakeOrders.exports(this.stock_take_order.id);
    },
  },
};
</script>